export const ZOOM_LOCAL_STORAGE_KEY = 'zoomMeeting';
export const ZOOMAPP_CONNECT_COOKIE = 'sa-connect';
export const ZOOMAPP_SESSION_COOKIE = 'sa-session';
export const ZOOMAPP_CTX_PARAM = 'sa-ctx';
export const ZOOMAPP_CONTEXT_HEADER = 'x-zoom-app-context';

export const ZOOM_VALIDATION_ERROR = 'ZOOM_VALIDATION_ERROR';
export const ZOOM_API_ERROR = 'ZOOM_API_ERROR';
export const ZOOM_API_CUSTOM_ERROR = 'ZOOM_API_CUSTOM_ERROR';
export const ZOOM_MEETING_SDK_WEB_ERROR = 'ZOOM_MEETING_SDK_WEB_ERROR';

export const EMPTY_LINK_ERROR_CODE = 'SA-ZV-001';
export const INVALID_LINK_ERROR_CODE = 'SA-ZV-002';
export const REGISTRATION_LINK_ERROR_CODE = 'SA-ZV-003';
export const EVENT_LINK_ERROR_CODE = 'SA-ZV-004';
